// src/pages/NewRole.jsx
import React, { useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { Autocomplete, TextField } from "@mui/material";

// Layout
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Services
import CrudService from "services/cruds-service";
// Tüm sayfalarınızın tanımlı olduğu routes.js
import routes from "routes";
import { buildPageOptions } from "../pages";

export default function NewRole() {
    const navigate = useNavigate();

    // Form state
    const [name, setName] = useState("");
    const [pages, setPages] = useState([]);
    const [error, setError] = useState("");

    // routes.js'ten dinámik olarak sayfa listesi çıkar
    const pagesOptions = useMemo(() => buildPageOptions(routes), []);

    const submitHandler = async (e) => {
        e.preventDefault();
        if (!name.trim()) {
            setError("Role name is required");
            return;
        }
        // Back-end artık allowedPages bekliyor
        const payload = {
            data: {
                type: "roles",
                attributes: {
                    name: name.trim(),
                    allowedPages: pages.map((p) => p.value),
                },
            },
        };
        try {
            await CrudService.createRole(payload);
            navigate("/user/role-management", {
                state: { value: true, text: "Role successfuly created" }, // doğru rota
            });
        } catch (err) {
            console.error(err);
            setError(err?.errors?.[0]?.detail || "An error occurred");
        }
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox mt={5} mb={9}>
                <Grid container justifyContent="center">
                    <Grid item xs={12} lg={8}>
                        <MDBox mt={6} mb={4} textAlign="center">
                            <MDTypography variant="h3" fontWeight="bold">
                                Add New Role
                            </MDTypography>
                            <MDTypography variant="h5" color="secondary">
                                This information will better define the role.
                            </MDTypography>
                        </MDBox>
                        <Card>
                            <MDBox component="form" onSubmit={submitHandler} p={3}>
                                {/* Role Name */}
                                <TextField
                                    fullWidth
                                    variant="standard"
                                    label="Role Name"
                                    value={name}
                                    onChange={(e) => {
                                        setName(e.target.value);
                                        setError("");
                                    }}
                                    margin="normal"
                                />

                                {/* Allowed Pages */}
                                <Autocomplete
                                    multiple
                                    options={pagesOptions}
                                    getOptionLabel={(opt) => opt.label}
                                    value={pages}
                                    onChange={(e, v) => setPages(v)}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="standard"
                                            label="Allowed Pages"
                                            placeholder="Select pages"
                                            margin="normal"
                                        />
                                    )}
                                />

                                {/* Error */}
                                {error && (
                                    <MDTypography variant="caption" color="error" display="block">
                                        {error}
                                    </MDTypography>
                                )}

                                {/* Buttons */}
                                <MDBox display="flex" justifyContent="flex-end" mt={2}>
                                    <MDButton
                                        variant="gradient"
                                        color="dark"
                                        size="small"
                                        onClick={() => navigate("/user/role-management")}
                                        sx={{ mr: 1 }}
                                    >
                                        Back
                                    </MDButton>
                                    <MDButton variant="gradient" color="dark" size="small" type="submit">
                                        Save
                                    </MDButton>
                                </MDBox>
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
}
